import { createParentCommunicatorController } from 'ui-forms-embed-components-frame-container/controllers/FormController/communicators/ParentCommunicatorController';
import { createFormCommunicatorController } from 'ui-forms-embed-components-frame-container/controllers/FormController/communicators/FormCommunicatorController';
export class FormController {
  constructor({
    applicationController
  }) {
    window._hsIsInFrame = true;
    this.formCommunicatorController = createFormCommunicatorController({
      applicationController
    });
    this.parentCommunicatorController = createParentCommunicatorController({
      applicationController
    });
    this.initialiseFormCommunicatorControllers();
    this.initialiseParentCommunicatorControllers();
  }
  initialiseFormCommunicatorControllers() {
    this.formCommunicatorController.initialiseFormCommunicators(this.parentCommunicatorController);
  }
  initialiseParentCommunicatorControllers() {
    this.parentCommunicatorController.initialiseParentCommunicatorControllers(this.formCommunicatorController);
  }
}
export const createFormController = ({
  applicationController
}) => new FormController({
  applicationController
});